import { APP_BUTTON_BLACKLIST_URLS } from '../constants';

/**
 * Проверяет, соответствует ли текущий путь одному из паттернов в блэклисте
 * @param pathname - текущий путь из useLocation
 * @returns true, если путь соответствует одному из паттернов блэклиста
 */
export const isPathInBlacklist = (pathname: string): boolean =>
    APP_BUTTON_BLACKLIST_URLS.some((pattern) => {
        // Заменяем :param на любые символы кроме слеша
        const regexPattern = pattern.replace(/:[\w]+/g, '[^/]+');
        const regex = new RegExp(`^${regexPattern}$`);

        return regex.test(pathname);
    });
